import React from "react";
import { Col, Container, Row } from "reactstrap";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";

import * as gameAction from "redux/game/action";
import * as loaderAction from "redux/loader/action";
import * as paramsAction from "redux/gameParams/actions";
import { withSocket } from "socket/context";
import Timer from "./timer";
import Teams from "./teams";
import JoinNow from "../lobby/joinNow";
class Verboden extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div>
        <Container fluid>
          <Row className="py-3 px-4">
            <Col sm={3} className="px-2">
              <JoinNow
                isBackButton
                type="verboden"
                className="verboden-card barcode"
                joinCodeTextClassName="scan-text"
              />
            </Col>
            <Col sm={9} className="px-2">
              <div className="verboden-card h-100 teams">
                <Teams />
                <Timer />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  loaderDetails: state.loaderDetails,
  paramsReducer: state.paramsReducer
});

const mapDispatchToProps = (dispatch) => {
  return {
    getGameData: (data) => dispatch(paramsAction.getGameData(data)),
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
    setPlayerCards: (data) => dispatch(gameAction.setPlayerCards(data))
  };
};
export default compose(
  withRouter,
  withSocket,
  connect(mapStateToProps, mapDispatchToProps)
)(Verboden);
